import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Card, Row, Col, Avatar, Space, Typography } from "antd";
import UserAvatarGroup from "~/components/user/UserAvatarGroup";
import UserLink from "~/components/user/UserLink";
import TimeAgoTag from "~/components/app/TimeAgoTag";
import CategoryFollowButton from "~/components/categories/CategoryFollowButton";
import { useState, useEffect } from "react";
import {
  checkCategoryFlags,
  fetchCategoryActiveUsers,
  showAppModal,
} from "~/redux/actions/app";
import { getUserInfo } from "~/redux/actions/user";

import events from "~/utils/events";

const { Text, Paragraph } = Typography;

const CategoryCounter = ({ name, count }) => {
  const countNumber = count || 0;
  let countValue = countNumber;
  if (countNumber > 1000) {
    countValue = Math.floor(countNumber / 1000);
    countValue = `${countValue}k`;
  }

  return (
    <span title={countNumber}>
      <span className="text-primary">{countValue}</span> {name}
    </span>
  );
};

const CategoryLogo = ({ category }) => {
  if (!category.logo_url) return;

  return (
    <Col flex="0 0 40px">
      <Avatar src={category.logo_url} />
    </Col>
  );
};

const CategoryCard = (props) => {
  const [category, setCategory] = useState(props.category);
  const [activeUsers, setActiveUsers] = useState([]);
  if (!props.category) return null;
  const isFollowed =
    props.flags?.followed?.includes(props.category.hashid) || false;
  const isCollaboration = props.collaboration;
  const Moderator = (user) => (
    <>
      <Row align="middle">
        <Space>
          <UserLink
            avatar
            user={user}
          />
          <Text type="secondary">
            <TimeAgoTag time={user.created_at} />
          </Text>
        </Space>
      </Row>
      {user.desc && (
        <Paragraph
          type="secondary"
          ellipsis={{ rows: 2 }}
          title={user.desc}
          style={{ margin: "5px 0" }}
        >
          {user.desc}
        </Paragraph>
      )}
    </>
  );

  const loadActiveUsers = () => {
    props.category &&
      fetchCategoryActiveUsers(props.category.id).then(setActiveUsers);
  };

  useEffect(() => {
    // 根据关注结果更新板块信息
    const handleCategoryFollow = (category, followed) => {
      setCategory(category);
      if (props.token && props.category?.hashid) {
        props.checkCategoryFlags(
          props.token,
          ["followed", "paid"],
          [props.category.hashid]
        );
      }
    };

    events.on("categoryFollow", handleCategoryFollow);
    return () => events.off("categoryFollow", handleCategoryFollow);
  }, []);

  useEffect(() => {
    setCategory(props.category);
    loadActiveUsers();
  }, [props.category]);

  useEffect(() => {
    if (props.token && props.category?.hashid) {
      props.checkCategoryFlags(
        props.token,
        ["followed", "paid"],
        [props.category.hashid]
      );
    }
  }, [props.category]);

  return (
    <Card
      title={isCollaboration ? "共学共创" : "版块详情"}
      extra={[
        <CategoryFollowButton
          key="follow"
          name={isCollaboration ? "共学" : undefined}
          followText={isCollaboration ? "加入" : "关注"}
          unfollowText={isCollaboration ? "加群" : "取关"}
          unfollowButtonType={isCollaboration ? "primary" : undefined}
          className={
            isFollowed && !isCollaboration ? "followed-btn" : "add-group-btn"
          }
          category={category}
          isFollowed={isFollowed}
          onUnfollow={
            isCollaboration
              ? () => props.showAppModal("CollaborationQrcodeModal")
              : undefined
          }
          onFollowed={(category) => {
            events.emit("categoryFollow", category, true);
            isCollaboration && props.showAppModal("CollaborationQrcodeModal");
            props.onFollowed && props.onFollowed(category);
          }}
          onUnfollowed={(category) => {
            if (!isCollaboration) {
              events.emit("categoryFollow", category);
              props.unFollowed && props.unFollowed(category);
            }
          }}
        />,
      ]}
    >
      <Space
        direction="vertical"
        size="small"
        style={{ width: "100%" }}
      >
        <Row type="flex">
          <Col flex="1">
            <h2>{category.name}</h2>
            <Row
              align="middle"
              style={{ fontSize: "0.9em" }}
            >
              <Space>
                <CategoryCounter
                  name="帖子"
                  count={category.posts_count}
                />
                <CategoryCounter
                  name="评论"
                  count={category.comments_count}
                />
                <CategoryCounter
                  name="关注"
                  count={category.followed_count}
                />
              </Space>
            </Row>
          </Col>
          <CategoryLogo category={category} />
        </Row>

        {category.description && <Text>{category.description}</Text>}

        <Text strong>{isCollaboration ? "发起人" : "版主"}</Text>
        {category.user ||
        (props.category.moderators && props.category.moderators.length > 0) ? (
          <>
            {category.user && <Moderator {...category.user} />}
            {props.category.moderators?.map((moderator) => (
              <Moderator
                {...moderator.user}
                desc={moderator.desc}
                key={moderator.id}
              />
            ))}
          </>
        ) : (
          <div>
            <span className="text-primary">空缺中，申请版主请于站长联系</span>
          </div>
        )}

        {activeUsers.length > 0 && (
          <>
            <Text strong>最近活跃</Text>
            <UserAvatarGroup users={activeUsers} />
          </>
        )}
      </Space>
    </Card>
  );
};
const mapStateToProps = (state) => ({
  collaboration: state.app?.collaboration,
  token: state.user?.token,
  flags: state.app?.flags || { followed: [], paid: [] },
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppModal,
      checkCategoryFlags,
      getUserInfo,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CategoryCard);
